/* ============================================================
   ZOOMIES theme — front-end behavior
   Vanilla JS, no dependencies. Mirrors the Base44 interactions.
   ============================================================ */
(function () {
  'use strict';

  var routes = window.zoomiesRoutes || {};
  var strings = window.zoomiesStrings || {};

  /* ---------- Utilities ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var fmt = window.zoomiesMoneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/g, value)
             .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100));
  }

  function toast(message) {
    var stack = $('#ToastStack');
    if (!stack) { return; }
    var el = document.createElement('div');
    el.className = 'toast';
    el.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg><span></span>';
    el.querySelector('span').textContent = message;
    stack.appendChild(el);
    setTimeout(function () {
      el.style.transition = 'opacity .3s, transform .3s';
      el.style.opacity = '0';
      el.style.transform = 'translateY(10px)';
      setTimeout(function () { el.remove(); }, 300);
    }, 2600);
  }

  /* ============================================================
     HEADER — mobile menu
     ============================================================ */
  function initHeader() {
    var toggle = $('[data-menu-toggle]');
    var menu = $('[data-mobile-menu]');
    if (!toggle || !menu) { return; }
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      var openIcon = $('[data-menu-icon-open]', toggle);
      var closeIcon = $('[data-menu-icon-close]', toggle);
      if (openIcon && closeIcon) {
        openIcon.hidden = open;
        closeIcon.hidden = !open;
      }
    });
  }
  /* ============================================================
     CART — AJAX add / drawer / line updates
     ============================================================ */
  var CartDrawer = {
    el: null, overlay: null, body: null,
    init: function () {
      this.el = $('[data-cart-drawer]');
      this.overlay = $('[data-cart-overlay]');
      this.body = $('[data-cart-body]');
      var self = this;

      $all('[data-cart-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          self.open();
        });
      });
      if (this.overlay) { this.overlay.addEventListener('click', function () { self.close(); }); }
      var closeBtn = $('[data-cart-close]');
      if (closeBtn) { closeBtn.addEventListener('click', function () { self.close(); }); }
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { self.close(); } });

      this.bindLineEvents();
    },
    open: function () {
      if (!this.el) { return; }
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      if (this.overlay) { this.overlay.classList.add('is-open'); }
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      if (!this.el) { return; }
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      if (this.overlay) { this.overlay.classList.remove('is-open'); }
      document.body.style.overflow = '';
    },
    // Re-render drawer body + counts using the Section Rendering API
    update: function () {
      var self = this;
      return fetch(routes.cart + '?section_id=cart-drawer-contents').then(function (r) {
        return r.text();
      }).then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        // Section render wraps output in a div; grab its inner content
        var inner = tmp.firstElementChild ? tmp.firstElementChild.innerHTML : tmp.innerHTML;
        if (self.body) {
          self.body.innerHTML = inner;
          self.bindLineEvents();
        }
      }).catch(function () {})
      .then(function () { return self.syncCounts(); });
    },
    syncCounts: function () {
      return fetch(routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          $all('[data-cart-count]').forEach(function (b) {
            b.textContent = cart.item_count;
            b.hidden = cart.item_count === 0;
          });
          $all('[data-cart-count-text]').forEach(function (b) { b.textContent = cart.item_count; });
          return cart;
        }).catch(function () {});
    },
    bindLineEvents: function () {
      var self = this;
      $all('[data-qty-up]').forEach(function (btn) {
        btn.onclick = function () { self.changeLine(btn.getAttribute('data-line-key'), 'up'); };
      });
      $all('[data-qty-down]').forEach(function (btn) {
        btn.onclick = function () { self.changeLine(btn.getAttribute('data-line-key'), 'down'); };
      });
      $all('[data-line-remove]').forEach(function (btn) {
        btn.onclick = function () { self.changeLine(btn.getAttribute('data-line-key'), 'remove'); };
      });
    },
    changeLine: function (key, dir) {
      var self = this;
      var line = $('[data-cart-line][data-line-key="' + key + '"]');
      var qtyEl = line ? $('[data-line-qty]', line) : null;
      var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      var next = dir === 'remove' ? 0 : (dir === 'up' ? current + 1 : Math.max(0, current - 1));

      fetch(routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: next })
      }).then(function (r) { return r.json(); })
        .then(function () {
          self.update();
          self.updateCartPage();
        }).catch(function () {});
    },
    updateCartPage: function () {
      // If we're on the full cart page, reload line prices/totals
      if (!$('[data-cart-page-form]')) { return; }
      fetch(routes.cart + '?section_id=main-cart').then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('.cart-page');
          var live = $('.cart-page');
          if (fresh && live) { live.replaceWith(fresh); CartDrawer.bindLineEvents(); }
        }).catch(function () {});
    }
  };

  function initAddToCart() {
    $all('[data-cart-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = $('[data-add-btn]', form) || form.querySelector('button[type="submit"]');
        if (btn) { btn.disabled = true; }
        var formData = new FormData(form);
        fetch(routes.cartAdd, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        }).then(function (r) { return r.json(); })
          .then(function (item) {
            if (btn) { btn.disabled = false; }
            toast((item.product_title || item.title || 'Item') + ' ' + (strings.addedToCart || 'added to cart!'));
            CartDrawer.update();
            CartDrawer.open();
          }).catch(function () { if (btn) { btn.disabled = false; } });
      });
    });
  }

  /* ============================================================
     PDP — variant selection, gallery, quantity, AJAX add
     ============================================================ */
  function initProductForm() {
    var form = $('#ProductForm');
    if (!form) { return; }

    var variantInput = $('[data-variant-id-input]', form);
    var priceEl = $('[data-price]');
    var compareEl = $('[data-compare]');
    var atcBtn = $('[data-atc]', form);
    var atcText = $('[data-atc-text]', form);
    var optionSelectors = $all('[data-option-selector]', form);

    function currentOptions() {
      return optionSelectors.map(function (s) { return s.value; });
    }

    function matchVariant() {
      if (!variantInput) { return; }
      var opts = currentOptions();
      var options = $all('option', variantInput);
      var matched = null;
      options.forEach(function (opt) {
        var ok = true;
        for (var i = 0; i < opts.length; i++) {
          if (opt.getAttribute('data-option' + (i + 1)) !== opts[i]) { ok = false; break; }
        }
        if (ok && matched === null) { matched = opt; }
      });
      if (!matched && options.length) { matched = options[0]; }
      if (!matched) { return; }

      variantInput.value = matched.value;
      if (priceEl) { priceEl.textContent = matched.getAttribute('data-price'); }
      var onSale = matched.getAttribute('data-on-sale') === 'true';
      if (compareEl) {
        if (onSale) { compareEl.textContent = matched.getAttribute('data-compare'); compareEl.style.display = ''; }
        else { compareEl.style.display = 'none'; }
      }
      var available = matched.getAttribute('data-available') === 'true';
      if (atcBtn) { atcBtn.disabled = !available; }
      if (atcText) { atcText.textContent = available ? (form.getAttribute('data-add-label') || 'Add to Cart') : 'Sold Out'; }
    }

    optionSelectors.forEach(function (s) { s.addEventListener('change', matchVariant); });

    // Quantity stepper
    var qtyInput = $('[data-qty-input]', form);
    var qtyDisplay = $('[data-qty-display]', form);
    var dec = $('[data-qty-decrease]', form);
    var inc = $('[data-qty-increase]', form);
    function setQty(n) {
      n = Math.max(1, n);
      if (qtyInput) { qtyInput.value = n; }
      if (qtyDisplay) { qtyDisplay.textContent = n; }
    }
    if (dec) { dec.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) - 1); }); }
    if (inc) { inc.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) + 1); }); }

    // Gallery thumbnails
    var mainImg = $('#PdpMainImage');
    $all('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg) { mainImg.src = thumb.getAttribute('data-full'); }
        $all('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // AJAX add
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atcBtn) { atcBtn.disabled = true; }
      var fd = new FormData(form);
      fetch(routes.cartAdd, { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          if (atcBtn) { atcBtn.disabled = false; }
          toast((item.product_title || item.title) + ' ' + (strings.addedToCart || 'added to cart!'));
          CartDrawer.update();
          CartDrawer.open();
        }).catch(function () { if (atcBtn) { atcBtn.disabled = false; } });
    });

    matchVariant();
  }
  /* ============================================================
     CAROUSEL — horizontal scroll arrows
     ============================================================ */
  function initCarousels() {
    $all('[data-carousel-track]').forEach(function (track) {
      var section = track.closest('section') || document;
      var prev = $('[data-carousel-prev]', section);
      var next = $('[data-carousel-next]', section);
      function scrollBy(dir) {
        var amount = track.clientWidth * 0.8;
        track.scrollBy({ left: dir === 'left' ? -amount : amount, behavior: 'smooth' });
      }
      if (prev) { prev.addEventListener('click', function () { scrollBy('left'); }); }
      if (next) { next.addEventListener('click', function () { scrollBy('right'); }); }
    });
  }

  /* ============================================================
     WISHLIST — localStorage backed
     ============================================================ */
  var Wishlist = {
    key: 'zoomies_wishlist',
    get: function () {
      try { return JSON.parse(localStorage.getItem(this.key)) || []; }
      catch (e) { return []; }
    },
    set: function (arr) {
      try { localStorage.setItem(this.key, JSON.stringify(arr)); } catch (e) {}
      this.updateBadge();
    },
    has: function (id) { return this.get().some(function (p) { return String(p.id) === String(id); }); },
    toggle: function (product) {
      var arr = this.get();
      var idx = arr.findIndex(function (p) { return String(p.id) === String(product.id); });
      var added;
      if (idx > -1) { arr.splice(idx, 1); added = false; }
      else { arr.push(product); added = true; }
      this.set(arr);
      return added;
    },
    updateBadge: function () {
      var count = this.get().length;
      $all('[data-wishlist-count]').forEach(function (b) {
        b.textContent = count;
        b.hidden = count === 0;
      });
    },
    init: function () {
      var self = this;
      $all('[data-wishlist-toggle]').forEach(function (btn) {
        var id = btn.getAttribute('data-product-id');
        if (self.has(id)) { btn.classList.add('is-active'); }
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var product = {
            id: id,
            handle: btn.getAttribute('data-product-handle'),
            title: btn.getAttribute('data-product-title'),
            url: btn.getAttribute('data-product-url'),
            image: btn.getAttribute('data-product-image'),
            price: btn.getAttribute('data-product-price'),
            compare: btn.getAttribute('data-product-compare')
          };
          var added = self.toggle(product);
          btn.classList.toggle('is-active', added);
          toast(added ? (strings.addToWishlist || 'Added to wishlist') : (strings.removeFromWishlist || 'Removed from wishlist'));
          if (window.WishlistDrawer && window.WishlistDrawer.el && window.WishlistDrawer.el.classList.contains('is-open')) {
            window.WishlistDrawer.render();
          }
          if (window.WishlistPage) { window.WishlistPage.render(); }
        });
      });
      this.updateBadge();
    }
  };
  window.Wishlist = Wishlist;

  /* ============================================================
     RECENTLY VIEWED — record on PDP, render on rails
     ============================================================ */
  var RecentlyViewed = {
    key: 'zoomies_recently_viewed',
    get: function () { try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; } },
    record: function () {
      var titleEl = $('.pdp-title');
      if (!titleEl) { return; }
      var card = {
        title: titleEl.textContent.trim(),
        url: location.pathname,
        image: (function () { var img = $('#PdpMainImage'); return img ? img.src : ''; })(),
        price: (function () { var p = $('[data-price]'); return p ? p.textContent.trim() : ''; })()
      };
      var arr = this.get().filter(function (p) { return p.url !== card.url; });
      arr.unshift(card);
      arr = arr.slice(0, 8);
      try { localStorage.setItem(this.key, JSON.stringify(arr)); } catch (e) {}
    },
    render: function () {
      var host = $('[data-recently-viewed]');
      if (!host) { return; }
      var grid = $('[data-recently-viewed-grid]', host);
      var items = this.get().filter(function (p) { return p.url !== location.pathname; });
      if (!items.length) { return; }
      grid.innerHTML = items.map(function (p) {
        return '<div class="product-card"><a href="' + p.url + '" class="product-card__media">' +
          (p.image ? '<img src="' + p.image + '" alt="' + p.title + '" loading="lazy">' : '') +
          '</a><a href="' + p.url + '" class="product-card__info"><h3 class="product-card__title">' + p.title +
          '</h3><div class="product-card__price-row"><span class="product-card__price">' + (p.price || '') + '</span></div></a></div>';
      }).join('');
      host.hidden = false;
    }
  };

  /* ============================================================
     WISHLIST DRAWER — slide-out panel, reads from localStorage
     ============================================================ */
  var WishlistDrawer = {
    el: null, overlay: null, body: null, empty: null,
    init: function () {
      this.el = $('[data-wishlist-drawer]');
      this.overlay = $('[data-wishlist-overlay]');
      this.body = $('[data-wishlist-drawer-body]');
      this.empty = $('[data-wishlist-empty]');
      if (!this.el) { return; }
      var self = this;

      $all('[data-wishlist-open]').forEach(function (btn) {
        btn.addEventListener('click', function (e) { e.preventDefault(); self.open(); });
      });
      if (this.overlay) { this.overlay.addEventListener('click', function () { self.close(); }); }
      $all('[data-wishlist-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.close(); });
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { self.close(); } });
    },
    open: function () {
      if (!this.el) { return; }
      this.render();
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      if (this.overlay) { this.overlay.classList.add('is-open'); }
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      if (!this.el) { return; }
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      if (this.overlay) { this.overlay.classList.remove('is-open'); }
      document.body.style.overflow = '';
    },
    render: function () {
      if (!this.body) { return; }
      var self = this;
      var items = Wishlist.get();
      var countEl = $('[data-wishlist-drawer-count]');
      if (countEl) { countEl.textContent = items.length; }

      if (!items.length) {
        this.body.innerHTML = '';
        this.body.hidden = true;
        if (this.empty) { this.empty.hidden = false; }
        return;
      }
      this.body.hidden = false;
      if (this.empty) { this.empty.hidden = true; }

      this.body.innerHTML = items.map(function (p) {
        var priceNum = parseInt(p.price, 10);
        var compareNum = parseInt(p.compare, 10);
        var priceStr = isNaN(priceNum) ? (p.price || '') : formatMoney(priceNum);
        var compareStr = (!isNaN(compareNum) && compareNum > priceNum) ? formatMoney(compareNum) : '';
        return '<div class="wl-item" data-wl-item="' + p.id + '">' +
          '<a href="' + p.url + '" class="wl-item__img">' + (p.image ? '<img src="' + p.image + '" alt="' + (p.title || '') + '">' : '') + '</a>' +
          '<div class="wl-item__info">' +
            '<a href="' + p.url + '" class="wl-item__title">' + (p.title || '') + '</a>' +
            '<div class="wl-item__price-row"><span class="wl-item__price">' + priceStr + '</span>' +
            (compareStr ? '<span class="wl-item__compare">' + compareStr + '</span>' : '') + '</div>' +
            '<div class="wl-item__actions">' +
              '<a href="' + p.url + '" class="wl-item__add">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>View product</a>' +
              '<button type="button" class="wl-item__remove" data-wl-remove="' + p.id + '" aria-label="Remove">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg></button>' +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('');

      $all('[data-wl-remove]', this.body).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-wl-remove');
          var arr = Wishlist.get().filter(function (p) { return String(p.id) !== String(id); });
          Wishlist.set(arr);
          $all('[data-wishlist-toggle][data-product-id="' + id + '"]').forEach(function (h) { h.classList.remove('is-active'); });
          var row = $('[data-wl-item="' + id + '"]', self.body);
          if (row) {
            row.style.transition = 'opacity .25s, transform .25s';
            row.style.opacity = '0';
            row.style.transform = 'translateX(20px)';
            setTimeout(function () { self.render(); }, 250);
          } else { self.render(); }
        });
      });
    }
  };
  window.WishlistDrawer = WishlistDrawer;

  /* ============================================================
     RECOMMENDATIONS — Shopify product recommendations API
     ============================================================ */
  function initRecommendations() {
    var host = $('[data-recommendations]');
    if (!host) { return; }
    var pid = host.getAttribute('data-product-id');
    var limit = host.getAttribute('data-limit') || 4;
    var base = host.getAttribute('data-url') || '/recommendations/products';
    var url = base + '?product_id=' + pid + '&limit=' + limit + '&section_id=related-products';
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var grid = tmp.querySelector('.product-grid');
        var target = $('[data-recommendations-grid]', host);
        if (grid && target) {
          target.innerHTML = grid.innerHTML;
          Wishlist.init();
          initAddToCart();
        }
      }).catch(function () {});
  }

  /* ============================================================
     Boot
     ============================================================ */
  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    CartDrawer.init();
    initAddToCart();
    initProductForm();
    initCarousels();
    Wishlist.init();
    WishlistDrawer.init();
    initRecommendations();
    RecentlyViewed.record();
    RecentlyViewed.render();
  });
})();